import { Span } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { formatPrice } from '@/domains/productDelivery/PayBoxRevamp/utils/formatPrice';
import { claimDeliveryFree } from '@/productDiscovery/ProductPage/common/modules/Delivery/translations';

const SUPER_PRO_SHIPPING_FEE_LIMIT = 200;

export type DeliveryPriceProps = {
  value: number;
  obsolete?: boolean;
  isSubscription?: boolean;
  weight?: 'regular' | 'semibold' | 'bold';
  free?: string;
};

export const DeliveryPrice = ({
  value,
  obsolete,
  isSubscription,
  weight: customWeight,
  free: customFree,
}: DeliveryPriceProps) => {
  const displayValue = isSubscription
    ? Math.max(0, value - SUPER_PRO_SHIPPING_FEE_LIMIT)
    : value;

  const isFreeDelivery = displayValue === 0;

  const weight =
    customWeight ??
    (isSubscription
      ? value <= SUPER_PRO_SHIPPING_FEE_LIMIT
        ? 'regular'
        : 'semibold'
      : isFreeDelivery || obsolete
        ? 'regular'
        : 'semibold');

  const free =
    customFree ||
    ((isSubscription && value <= SUPER_PRO_SHIPPING_FEE_LIMIT) || isFreeDelivery
      ? claimDeliveryFree.toLowerCase()
      : undefined);

  return (
    <Span
      scale="body2"
      weight={weight}
      className={obsolete && value ? 'line-through' : ''}
    >
      {free ? free : formatPrice(displayValue)}
    </Span>
  );
};
